<script lang="ts">
  import Panel from '@components/panel.svelte'
  import Image from '@components/image.svelte'
  import {
    ordinalNumber,
    type GameraTeamReference,
    type GoalEvent,
  } from '@statmuse/core/gamera'
  import { players, lineScore } from './stores'

  export let play: GoalEvent
  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined
  export let shootOut = false

  $: team =
    awayTeam?.teamId === play.teamId
      ? awayTeam
      : homeTeam?.teamId === play.teamId
      ? homeTeam
      : undefined

  $: player = $players[play.playerId ?? 0]

  $: assistingPlayers = play.assistPlayerId
    ?.map((x) => $players[x])
    .filter((x) => !!x)
</script>

<Panel
  class="!pb-0"
  background={team?.colors?.backgroundColor}
  foreground={team?.colors?.foregroundColor}
>
  <div class="flex justify-between">
    <p class="font-semibold">
      {#if shootOut}
        Shootout
      {:else}
        {`${
          play?.period < 4
            ? ordinalNumber(play?.period)
            : play?.period === 4
            ? ''
            : play?.period - 3
        }${play?.period < 4 ? '' : 'OT'}`}
        {play?.clock ?? '12:00'}
      {/if}
    </p>
    <p class="flex">
      <span class:font-semibold={team?.teamId === awayTeam?.teamId}>
        {play?.awayPoints +
          (shootOut && team?.teamId === awayTeam?.teamId ? 1 : 0)}
      </span>
      <span>-</span>
      <span class:font-semibold={team?.teamId === homeTeam?.teamId}>
        {play?.homePoints +
          (shootOut && team?.teamId === homeTeam?.teamId ? 1 : 0)}
      </span>
    </p>
  </div>
  <div class="flex mt-2">
    <div class="flex-1 space-y-1 pb-2 pt-1">
      <p>
        {player?.shortName ?? player?.longName ?? ''}
      </p>
      <div class="flex items-center gap-3">
        <div
          class="rounded-2xl px-2"
          style={team?.colors
            ? `background:${team.colors.foregroundColor};color:${team.colors.backgroundColor};`
            : undefined}
        >
          Goal
        </div>
        {#if play.strength === 'powerPlay'}
          <p>Power Play</p>
        {/if}
      </div>
      {#if assistingPlayers}
        <div class="text-sm opacity-50 flex">
          <p class="mr-1.5">Assists:</p>
          <div class="flex gap-2">
            {#each assistingPlayers as p (p.id)}
              <p>{p.shortName ?? p.longName}</p>
            {/each}
          </div>
        </div>
      {/if}
    </div>
    {#if player?.media.bust}
      <Image
        src={player.media.bust.imageUrl}
        alt={player.longName ?? ''}
        width={120}
        height={90}
        class="h-[75px] max-w-[100px] object-contain object-right-bottom self-end"
      />
    {/if}
  </div>
</Panel>
